import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars, faClipboardList, faTimes, faSwimmer, faTrash, faEdit, faMoneyBillWave,
  faPaperPlane, faCheck,
} from '@fortawesome/free-solid-svg-icons';

export default function addIcons() {
  library.add(
    faBars,
    faClipboardList,
    faSwimmer,
    faTimes,
    faTrash,
    faEdit,
    faMoneyBillWave,
    faPaperPlane,
    faCheck,
  );
}
